import { ofetch } from 'ofetch';

export default defineNuxtPlugin(() => {
  const { APP_PREFIX } = useRuntimeConfig().public;
  globalThis.$fetch = ofetch.create({
    headers: { 'X-Snapr-Prefix': APP_PREFIX },
  });
});
